import React from 'react';
import cn from 'classnames';
import Container from '../Container';
import { Title } from '@landing/ui';
import Slider from '../Slider';
import Slide from './Slide';

import * as styles from './Partners.module.scss';

export default function Partners({ title, description, slides, theme = 'light' }) {
  const isDark = theme === 'dark';
  const isSingle = slides.length === 1;
  const slidesToShow = slides.length > 3 ? 3 : slides.length;

  const config = {
    desktopSlidesToShow: slidesToShow,
    desktopSlidesToScroll: slidesToShow,
    tabletSlidesToShow: slidesToShow,
    tabletSlidesToScroll: slidesToShow,
  };

  const containerProps = isDark
    ? { background: 'transparent', className: styles.dark }
    : { background: 'gray', className: styles.light, theme: 'stairs' };

  return (
    <Container id="partners" {...containerProps}>
      <div className={cn(styles.layout, isSingle && styles.horizontal)}>
        <div className={styles.header}>
          <Title tag="h2" color={isDark ? 'white' : undefined}>
            {title}
          </Title>
          {description && <p className={styles.description}>{description}</p>}
        </div>
        <div className={cn(styles.sliderWrapper, !isSingle && 'defaultSlider')}>
          <Slider slides={slides} theme={isDark ? undefined : 'white'} {...config}>
            {slides.map(slide => (
              <div key={slide.title || slide.alt} className={styles.slide}>
                <Slide {...slide} theme={theme} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </Container>
  );
}
